module.exports = __webpack_public_path__ + "img/card2.53d61ca3.png";